'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $plp = {
  sortby_dropdown: 'select#plp-sort-by'
};

/**
*
* ------------------------------------------------------------------------------
*
*
* @namespace collection
*/

(0, _jquery2.default)(document).ready(function () {
  listeners();
  set_active_sort_by();
});

function listeners() {
  // $(document).on('click', $cart.trigger_open, function(){
  //
  // });
  (0, _jquery2.default)($plp.sortby_dropdown).on('change', function () {
    var sort_value = this.value;
    sort_by(sort_value);
  });
}

function set_active_sort_by() {
  if (window.location.search.indexOf('?sort_by=') > -1) {
    var url = window.location.search;
    var param = url.substr(url.indexOf("?sort_by=") + 9);
    (0, _jquery2.default)($plp.sortby_dropdown).removeAttr('selected');
    (0, _jquery2.default)('select#plp-sort-by option[value="' + param + '"]').attr('selected', 'selected');
  }
}

function sort_by(sort_value) {
  var url = window.location.pathname + "?sort_by=" + sort_value;
  document.location = url;
}